import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import { ReactNode } from 'react';
import { VizSubtitle } from '../viz.types';
import VizSubtitleLine from './VizSubtitleLine';

interface VizBlockFrameProps {
  title: string;
  subtitle?: VizSubtitle | null;
  header?: ReactNode;
  actions?: ReactNode;
  sx?: SxProps<Theme>;
  children: ReactNode;
}

const VizBlockFrame = ({ title, subtitle, header, actions, sx, children }: VizBlockFrameProps) => (
  <Stack
    sx={[
      { width: '100%', minWidth: 0, my: 1, gap: 2.5, containerType: 'inline-size' },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    <Stack sx={{ gap: 1.5, minWidth: 0 }}>
      <Stack sx={{ gap: 0.75 }}>
        <Typography variant="subtitle2" color="tertiary.main">
          {title}
        </Typography>
        <VizSubtitleLine subtitle={subtitle} />
      </Stack>
      {(header || actions) && (
        <Stack direction="row" alignItems="center" sx={{ gap: 2, justifyContent: 'space-between' }}>
          <Stack sx={{ minWidth: 0 }}>{header}</Stack>
          {actions}
        </Stack>
      )}
    </Stack>
    {children}
  </Stack>
);

export default VizBlockFrame;
